import { parseEnum } from "@/lib/enums.util";
import { centsToEuros, eurosToCents } from "@/lib/money.util";
import { GetOneExpeditionBoResponseDto } from "@/types/api/api-types";
import { ExpeditionBlockedReasonEnum } from "@/constants/enums/expeditionBlockedReason.enum";
import { DefaultValues } from "react-hook-form";
import { z } from "zod";

const money = z.number().nonnegative().finite();

export const ReturnModalSchema = z.object({
  blockedReason: z.nativeEnum(ExpeditionBlockedReasonEnum),
  transportHt: money,
  packaging: money,
  packagingProtection: money,
  taxes: money,
  insurance: money,
  tva: money,
});

export type ReturnModalData = z.infer<typeof ReturnModalSchema>;

export const getReturnModalDefaultValues = (
  expedition: GetOneExpeditionBoResponseDto,
): DefaultValues<ReturnModalData> => {
  const invoiceData = expedition.expeditionReturnBillingDetail?.expeditionInvoiceData;

  return {
    blockedReason: parseEnum(ExpeditionBlockedReasonEnum, expedition.blockedReason),
    transportHt: centsToEuros(invoiceData?.transportHt),
    packaging: centsToEuros(invoiceData?.packaging),
    packagingProtection: centsToEuros(invoiceData?.packagingProtection),
    taxes: centsToEuros(invoiceData?.taxes),
    insurance: centsToEuros(invoiceData?.insurance),
    tva: centsToEuros(invoiceData?.tva),
  };
};

export const toReturnUpdatePayload = (data: ReturnModalData) => ({
  blockedReason: data.blockedReason,
  transportHt: eurosToCents(data.transportHt),
  packaging: eurosToCents(data.packaging),
  packagingProtection: eurosToCents(data.packagingProtection),
  taxes: eurosToCents(data.taxes),
  insurance: eurosToCents(data.insurance),
  tva: eurosToCents(data.tva),
});
